
import { Typography, Box, styled } from "@mui/material";

// variables
    const primary_color = 'black';
    const secondary_color = 'white';

    const FooterStyle = styled(Box)`
        position: fixed;
        bottom: 0;
        width: 100%;
        // margin-top: 100%;
        background-color: ${secondary_color};
        color: ${primary_color};
        padding: 10px;
    `;

const Footer =()=>{
    return(
        <>
        <br/><br/>
            <FooterStyle>
                <Typography style={{textAlign:'center'}}>
                    Made with &#10084; by Aminat Fowoke Balogun   &copy;
                </Typography>
            </FooterStyle>


        </>
    )
}

export default Footer;